import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import warningIcon from '../../assets/images/icons/warning.svg'

const CommonModal = (props) => {
    const { handleClose, show, handleDelete } = props

    return (
        <Modal centered show={show} onHide={handleClose} size="md">
            {/* <Modal.Header closeButton>
            <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header> */}
            <Modal.Body className='text-center'>
                <div className="icon-warning-wrapper my-3 mt-4">
                    <img src={warningIcon} alt="" />
                </div>
                <p className='mx-4 my-4 px-5'>
                    {props?.text}
                </p>

                <div className="text-content-wrapper mt-3">
                    <div>
                        <Button className='modal-cancel-btn' onClick={handleClose}>
                            CANCEL
                        </Button>
                    </div>
                    <div>
                        <Button className='modal-delete-btn' onClick={() => {
                            handleDelete()
                            handleClose()
                        }}>
                            DELETE
                        </Button>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='border-0 mt-2'>

            </Modal.Footer>
        </Modal>
    )
}

export default CommonModal